import store from '@/store'
import axios from 'axios'
import { Message,
  MessageBox } from 'element-ui'
import util from '@/libs/util'

// 创建一个错误
function errorCreate(msg) {
  const error = new Error(msg)
  errorLog(error)
  throw error
}

// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  store.dispatch('d2admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error
    }
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(error)
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
}

function getAccountSetId() {
  // store.state.mustParams.user.empId
  console.log(store.state.d2admin.finance)

  return null
}

// 创建一个 axios 实例
const service = axios.create({

  baseURL: process.env.NODE_ENV == 'development' ? 'finance-api' : process.env.VUE_APP_API,
  // baseURL: process.env.NODE_ENV == 'development' ? process.env.VUE_APP_API:"",
  // baseURL: 'finance-api',
  timeout: 300000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = util.cookies.get('token')
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    // config.headers['X-Token'] = token
    config.headers['Authorization'] = token

    // 添加账套信息
    const account_set_id = util.cookies.get('ACCOUNT_SET_ID')
    config.headers['AccountSetId'] = account_set_id

    // 添加财务期数ID
    const term_id = util.cookies.get('TERM_ID')
    config.headers['TermId'] = term_id

    return config
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // const { status } = response
    // // 有 code 代表这是一个后端接口 可以进行进一步的判断
    // switch (status) {
    //   case 200:
    //     // [ 示例 ] code === 0 代表没有错误
    //     return dataAxios
    //   case '401':
    //     // [ 示例 ] 其它和后台约定的 code
    //     errorCreate(`[ code: ${status} ] ${dataAxios}: ${response.config.url}`)
    //     break
    //   default:
    //     // 不是正确的 code
    //     errorCrea te(dataAxios)
    //     break
    // }

    // 这个状态码是和后端约定的
    const { code } = dataAxios
    // 根据 code 进行判断
    if(response.config.responseType === 'blob'){
      console.log("🚀 ~ file: index.js:108 ~ response", response, dataAxios)
      return response
    } else if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios // 不能直接返回response,否则登录不上
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 200:
          // [ 示例 ] code === 200 代表没有错误
          return dataAxios.data
        case 401:
          // [ 示例 ] code === 401 权限验证没通过
          reAuthorize()
          return Promise.reject(dataAxios.message ? dataAxios.message : response)
        default:
          // 不是正确的 code
          errorCreate(`${dataAxios.msg}`)
          break
      }
    }
  },
  error => {
    if (error && error.response) {
      
      switch (error.response.status) {
        case 400:
          error.message = new RegExp('[\\u4E00-\\u9FFF]+', 'g').test(
                            error.response.data
                        )
                            ? error.response.data
                            : '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    if (error.response.status === 401) {
      reAuthorize()
    } else {
      errorLog(error)
    }
    return Promise.reject(error)
  }
)

// 重新授权确认
function reAuthorize() {
  MessageBox.confirm('您的授权已过期或在其他地方登录，是否重新登录？', '授权过期', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      util.cookies.remove('token')
      location.reload()
    })
    .catch(() => {
    })
}

export default service
